export default function IconPlayTransparent() {
  return (
    <svg width="32" height="32" viewBox="0 0 64 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.8" d="M63.5 32C63.5 49.397 49.397 63.5 32 63.5C14.603 63.5 0.5 49.397 0.5 32C0.5 14.603 14.603 0.5 32 0.5C49.397 0.5 63.5 14.603 63.5 32Z" fill="currentColor" fillOpacity="0.15" stroke="currentColor" />
      <path d="M28.0058 22.0259C26.1603 20.9688 24.6641 21.8348 24.6641 23.9585V39.6303C24.6641 41.7561 26.1603 42.621 28.0058 41.5649L41.7239 33.7092C43.57 32.6518 43.57 30.9386 41.7239 29.8815L28.0058 22.0259Z" fill="currentColor" />
    </svg>

  );
}
